<template>
  <!-- *RPD MHOR  Appv 0.91
* Copyright (c) 2025, Blue Cover Six LLC . ?John Molt All rights reserved.
Code licensed under contract To Reno Police Department / City of Reno, in perpetuity -->
  <div>
    <div id="all_cards" style="max-width: none; width: 100%">
      <v-container fluid>
        <v-card
          v-for="reg in lst_regs"
          style="max-width: none; width: 100%"
          :key="reg.registrationId"
          dark
          class="ma-0 pa-0 mt-3 grey darken-3"
          elevation="3"
        >
          <v-card-title>{{ reg.lname }}, {{ reg.fname }} </v-card-title>

          <v-card-text>
             <v-row dense>
                <v-col cols="12" md="12">
                  <label>Modified</label><br />
                  <output>{{ reg.s_date}}</output>
                </v-col>
              </v-row>
            <v-row dense>
              <v-col cols="12" md="4">
                <label>Reference #</label><br />
                <output>{{ reg.registrationId | prepend100 }}</output>
              </v-col>

              <v-col cols="12" md="4">
                <label>Approved</label><br />
                <output>{{ reg.approved }}</output>
              </v-col>

              <v-col cols="12" md="4" style="padding-top: 22px;">
                <v-checkbox
                  v-model="reg.rec_disp_email"
                  label="Sent Rec./Disp Email"
                 color="white"
                  hide-details
                  readonly
                  class="mt-0 pt-0"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col col="12" md="4"
                ><label>Phone</label><output>{{ reg.phone }}</output></v-col
              >
              <v-col col="12" md="4"
                ><label>Address</label><output>{{ reg.address }}</output></v-col
              >
              <v-col col="12" md="4"
                ><label>Email</label><output>{{ reg.email }}</output></v-col
              >
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-row dense
              ><v-col cols="12" md="2">
                <v-btn class="btn-size" dark @click="edit(reg)"
                  ><v-icon class="mr-1">$edit</v-icon>View/Edit</v-btn
                >
              </v-col>
              <v-col cols="12" md="2">
                <v-btn class="btn-size" dark @click="del_prompt(reg)"
                  ><v-icon class="mr-1">$del</v-icon>Delete</v-btn
                >
              </v-col></v-row
            >
          </v-card-actions>
        </v-card>
      </v-container>
    </div>
    <div
      style="height: 2px"
      v-intersect="{
        handler: onIntersect,
        options: { threshold: 0.25, rootMargin: '0px 0px 300px 0px' },
      }"
    ></div>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
.v-expansion-panel-content__wrap {
  background-color: red;
  padding: 0 !important;
}
label {
  font-weight: 800;
}
output {
  margin-left: 5px;
  font-size: 16px;
}
/* Base: 0px and up (default styles) */
@media (min-width: 0px) {
  .btn-size {
    width: 100%;
  }
}

/* Breakpoint: 768px and up */
@media (min-width: 768px) {
  .btn-size {
    width: auto;
  }
}
</style>

<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "Recents",
  mixins: [bus_common],
  props: ["update_recents"],
  data: function () {
    return {
      lst_regs: [],
      recent_count: 0,
      isLoading: false, // true while you’re fetching data
      hasMore: true, // flip to false when no more results to load
      lastFire: 0, // internal timestamp for throttling
      minInterval: 500, // minimum ms gap between triggers
    };
  },
  watch: {
    update_recents: function () {
      if (this.update_recents != null) {
        this.get_recents();
      }
    },
  },

  filters: {
    prepend100(value) {
      return "100" + String(value);
    },
  },

  computed: {},
  methods: {
    prepend100x(num) {
      return "100" + String(num);
    },
    edit(reg) {
      this.$emit("edit_in", reg);
    },
    del_prompt(reg) {
      var self = this;
      this.swall_diag(
        "Delete?",
        "You are deleting mental health registration for '" +
          reg.fname +
          " " +
          reg.lname +
          "'. Do you wish to continue",
        "question",
        function () {
          self.$emit("del", reg);
        },
        null,
        null,
        function () {}
      );
    },

    onIntersect(entries) {
      const [entry] = entries;
      if (!entry || !entry.isIntersecting) return; // only when visible
      if (!this.hasMore || this.isLoading) return; // guard flags

      // throttle
      const now = Date.now();
      if (now - this.lastFire < this.minInterval) return;
      this.lastFire = now;

      this.isLoading = true;
      this.loadMore()
        .catch((err) => console.error("loadMore failed:", err))
        .finally(() => {
          this.isLoading = false;
        });
    },
    async loadMore(recent_count) {
      this.show_loader(true);

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.count = this.recent_count;
      formIn.page = 5;

      console.log("recent count: " + this.recent_count);

      formIn.apiname = "get_recents";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);
          if (data.length == 0) {
            console.log("length 0");
            self.hasMore = false;
          } else {
            console.log("length " + data.length);
            for (let index = 0; index < data.length; index++) {
              const reg = data[index];
              reg.triggers = reg.triggers.split(",");
                reg.s_date = this.format_date_us(reg.s_date);
              self.lst_regs.push(reg);
            }

            self.recent_count = self.lst_regs.length;
          }
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error search", msg.msg, "error", null, null);
        });
    },
    get_recents(recent_count) {
      this.show_loader(true);
    console.log("get_recents");
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.count = this.recent_count;
      formIn.page = 3;

      formIn.apiname = "get_recents";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);
          this.lst_regs = this.mno(data);
          this.lst_regs.forEach((reg) => {
            reg.triggers = reg.triggers.split(",");
            reg.s_date = this.format_date_us(reg.s_date);
          });
          this.recent_count = data.length;
          console.log("data count: " + this.recent_count);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error search", msg.msg, "error", null, null);
        });
    },
    init: function () {
      //  this.get_recents(0);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>

<style scoped></style>
